module.exports = __webpack_public_path__ + "img/zp_logo.7eeb8d56.png";